export class SchoolIntegrationResponse {
    IntegrationSystemName: string;
    FlightSchoolName: string;
    Location: string;
    ResponseType: SchoolIntegrationResponseType;
    ErrorMessage?: string;
    IntegrationRequestToken?: any;
}

export enum SchoolIntegrationResponseType {
    ApproveIntegration = 1,
    CreateNewSchool = 2,
    IntegrationError = 3
}